import { Loadable } from '..';
import { BundleAction, BundleTimeUnit, OrangeProvisioningZone } from './commands';

/**
 * The number of seconds the application will wait before refreshing provisioning order details from the server.
 */
export const OrangeProvisioningOrderCacheTimeout = 300;

export interface ProductOrder {
  id: number;
  startDate: Date;
  endDate: Date;
  frequency: number;
  frequencyUnit: BundleTimeUnit;
  buckets: Bucket[];
}

export interface Bucket {
  id: number;
  endDate: Date;
  type: BundleAction;
  volume: number;
  zone: OrangeProvisioningZone;
}

export type ProductOrderState = Loadable<ProductOrder>;

export const getDefaultProductOrderState = (): ProductOrderState => {
  return {
    id: 0,
    buckets: [],
    startDate: new Date(),
    endDate: new Date(),
    frequency: 0,
    frequencyUnit: 'unknown',
    isLoading: false,
  };
};
